import { SubscriptionType, SubscriptionEventType } from '../enums';

export interface Subscription {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  partnerId: string;
  userId: string;
  event: SubscriptionEventType;
  type: SubscriptionType;
  conditions: Conditions;
  subscriber: object | null;
  enabled: boolean;
  description: string | null;
}

export type PayloadOrderInput = {
  description: string;
  event: string;
  sender: string;
  receiver: string;
  order?: string;
  status?: string[];
  category?: string;
};

export type PayloadOrderOutput = {
  description: string;
  event: string;
  conditions: {
    sender: string;
    receiver: string;
    category?: string;
    order?: {
      id: string;
      status?: string[];
    };
  };
};

export interface Conditions {
  sender: string;
  receiver: string;
  category?: string;
  order?: {
    id: string;
    status?: string[];
  };
}
